import { type ApiClient } from "@anna-money/anna-web-lib/api";
import { AnnaError } from "@anna-money/anna-web-lib/utils";
import { CheckoutResponseData, PaymentStatusResponse, RefundData } from "./billingTypes";

export class BillingClient {
  private readonly _apiClient: ApiClient;
  private readonly _baseUrl = "api/formations/billing";

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  async charge(): Promise<CheckoutResponseData> {
    try {
      const response = await this._apiClient.post(`${this._baseUrl}/charge`, {});

      return response.getData(CheckoutResponseData);
    } catch (error) {
      console.error(new AnnaError("Failed to charge customer", { cause: error }));

      return new CheckoutResponseData({ isPaid: false, paymentRequired: true });
    }
  }

  // Left to throw, unlike charge() above: a swallowed failure here used to come back as
  // canRequestRefund: false, indistinguishable from a genuine "no refund available" — which told
  // an eligible rejected customer nothing recoverable was available instead of surfacing a retry.
  // Each caller decides for itself what to fall back to.
  async getPaymentStatus(): Promise<PaymentStatusResponse> {
    const response = await this._apiClient.get(`${this._baseUrl}/payment`);

    return response.getData(PaymentStatusResponse);
  }

  // Left to throw, unlike the reads above: the customer just clicked a confirmed refund request,
  // so a failure here has to reach them, not fail silently behind a swallowed read.
  async refund(): Promise<RefundData> {
    const response = await this._apiClient.post(`${this._baseUrl}/refund`, {});

    return response.getData(RefundData);
  }
}
